// support simple version follow below format only
// {major}.{minor}.{bugfix}
// for more complex version, can consider using https://semver.org/ later
export const DEFAULT_VERSION = '0.0.0';
